module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_4@2x.97c9baa5.png";